import { call, put, takeLatest, all } from 'redux-saga/effects';

import { addAPIError, removeAPIError } from 'redux/apiErrors/sagas';

import {
  listWineTypesFilter,
  listWineVarietalsFilter,
  listWineCountryCodesFilter,
  listWineRegionsFilter,
  listWineAppellationsFilter,
  listVendorsFilter
} from './api';
import {
  PRODUCT_FILTER_REQUESTING,
  LIST_PRODUCT_FILTER_WINE_TYPES_REQUEST,
  LIST_PRODUCT_FILTER_WINE_TYPES_SUCCESS,
  LIST_PRODUCT_FILTER_WINE_VARIETALS_REQUEST,
  LIST_PRODUCT_FILTER_WINE_VARIETALS_SUCCESS,
  LIST_PRODUCT_FILTER_WINE_COUNTRY_CODES_REQUEST,
  LIST_PRODUCT_FILTER_WINE_COUNTRY_CODES_SUCCESS,
  LIST_PRODUCT_FILTER_WINE_REGIONS_REQUEST,
  LIST_PRODUCT_FILTER_WINE_REGIONS_SUCCESS,
  LIST_PRODUCT_FILTER_WINE_APPELLATIONS_REQUEST,
  LIST_PRODUCT_FILTER_WINE_APPELLATIONS_SUCCESS,
  LIST_PRODUCT_FILTER_VENDORS_REQUEST,
  LIST_PRODUCT_FILTER_VENDORS_SUCCESS,
  RESET_PRODUCT_FILTER_ISFETCHING
} from './constants';

function* listWineTypes(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: PRODUCT_FILTER_REQUESTING });
    const response = yield call(listWineTypesFilter, action.slug);
    yield put({
      type: LIST_PRODUCT_FILTER_WINE_TYPES_SUCCESS,
      payload: response.data
    });
  } catch (error) {
    yield put({ type: RESET_PRODUCT_FILTER_ISFETCHING });
    yield call(addAPIError, error);
  }
}

function* listWineVarietals(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: PRODUCT_FILTER_REQUESTING });
    const response = yield call(listWineVarietalsFilter, action.slug);
    yield put({
      type: LIST_PRODUCT_FILTER_WINE_VARIETALS_SUCCESS,
      payload: response.data
    });
  } catch (error) {
    yield put({ type: RESET_PRODUCT_FILTER_ISFETCHING });
    yield call(addAPIError, error);
  }
}

function* listWineCountryCodes(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: PRODUCT_FILTER_REQUESTING });
    const response = yield call(listWineCountryCodesFilter, action.slug);
    yield put({
      type: LIST_PRODUCT_FILTER_WINE_COUNTRY_CODES_SUCCESS,
      payload: response.data
    });
  } catch (error) {
    yield put({ type: RESET_PRODUCT_FILTER_ISFETCHING });
    yield call(addAPIError, error);
  }
}

function* listWineRegions(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: PRODUCT_FILTER_REQUESTING });
    const response = yield call(listWineRegionsFilter, action.slug);
    yield put({
      type: LIST_PRODUCT_FILTER_WINE_REGIONS_SUCCESS,
      payload: response.data
    });
  } catch (error) {
    yield put({ type: RESET_PRODUCT_FILTER_ISFETCHING });
    yield call(addAPIError, error);
  }
}

function* listWineAppellations(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: PRODUCT_FILTER_REQUESTING });
    const response = yield call(listWineAppellationsFilter, action.slug);
    yield put({
      type: LIST_PRODUCT_FILTER_WINE_APPELLATIONS_SUCCESS,
      payload: response.data
    });
  } catch (error) {
    yield put({ type: RESET_PRODUCT_FILTER_ISFETCHING });
    yield call(addAPIError, error);
  }
}

function* listVendors(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: PRODUCT_FILTER_REQUESTING });
    const response = yield call(listVendorsFilter, action.slug);
    yield put({
      type: LIST_PRODUCT_FILTER_VENDORS_SUCCESS,
      payload: response.data
    });
  } catch (error) {
    yield put({ type: RESET_PRODUCT_FILTER_ISFETCHING });
    yield call(addAPIError, error);
  }
}

function* watchList() {
  yield takeLatest(LIST_PRODUCT_FILTER_WINE_TYPES_REQUEST, listWineTypes);
  yield takeLatest(
    LIST_PRODUCT_FILTER_WINE_VARIETALS_REQUEST,
    listWineVarietals
  );
  yield takeLatest(
    LIST_PRODUCT_FILTER_WINE_COUNTRY_CODES_REQUEST,
    listWineCountryCodes
  );
  yield takeLatest(LIST_PRODUCT_FILTER_WINE_REGIONS_REQUEST, listWineRegions);
  yield takeLatest(
    LIST_PRODUCT_FILTER_WINE_APPELLATIONS_REQUEST,
    listWineAppellations
  );
  yield takeLatest(LIST_PRODUCT_FILTER_VENDORS_REQUEST, listVendors);
}

export default function* productFilterSagas() {
  yield all([watchList()]);
}
